// extracted by mini-css-extract-plugin
export default {"cartIcon":"styles_cartIcon__53KFD"};